import { render, staticRenderFns } from "./PLUD.vue?vue&type=template&id=e4bb54fe&scoped=true"
import script from "./PLUD.vue?vue&type=script&lang=js"
export * from "./PLUD.vue?vue&type=script&lang=js"
import style0 from "./PLUD.vue?vue&type=style&index=0&id=e4bb54fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bb54fe",
  null
  
)

export default component.exports